import { Star, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { COMPANY } from "@/data/content";

// Avis : seule la note globale réelle (confirmée par le client) est affichée.
// Les témoignages individuels seront réintégrés avec les vrais avis Google.
const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/Serrurier+Lagny+sur+Marne+26+Rue+Freycinet+77400";

export default function Testimonials() {
  return (
    <section id="avis" data-testid="testimonials" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-golddark">
              <span className="w-8 h-px bg-brand-gold" /> Avis clients
            </span>
            <h2 className="mt-5 font-display font-semibold text-4xl md:text-6xl tracking-tight text-brand-navy leading-[1.05]">
              La preuve par les avis
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Nos clients nous évaluent directement sur Google. Consultez leurs
              avis vérifiés et partagez le vôtre après votre intervention.
            </p>
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="mt-7 inline-flex items-center gap-2 bg-brand-navy hover:bg-brand-navy2 text-white px-7 py-3.5 rounded-full font-semibold text-base transition-colors duration-300"
            >
              Voir nos avis sur Google{" "}
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
          <div className="flex items-center gap-4 rounded-2xl border border-brand-line bg-brand-mist px-8 py-6 self-start">
            <div className="font-display font-semibold text-6xl text-brand-navy leading-none">
              {COMPANY.rating}
            </div>
            <div>
              <div className="flex gap-0.5 text-brand-gold">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <div className="mt-1.5 text-xs uppercase tracking-[0.12em] text-slate-500 font-medium">
                {COMPANY.reviewsCount} avis · Google
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
